module.exports = __webpack_public_path__ + "static/img/cj_fd.086c0150.png";